<div class="popup-title">{{ sitecore.betslip.betslipRuleUpdatePopupUS.Title }}</div>
<div class="popup-text" [innerHTML]="sitecore.betslip.betslipRuleUpdatePopupUS.PopupText"></div>
<button class="btn btn-primary popup-btn" (click)="close()">{{ sitecore.betslip.betslipRuleUpdatePopupUS.Messages.ButtonText }}</button>
<a class="settings-url" [href]="settingsURL">{{ sitecore.betslip.betslipRuleUpdatePopupUS.Messages.BetslipSettingsLinkText }}</a>
